import styled from 'styled-components';

const CoauthorButtonGroup = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: 37,
  marginTop: 12,
  gap: 32,
  '& > a': {
    color: "#0072ab",
    fontWeight: 'bold',
  },
  '& > button': {
    border: 'none',
    background: 'transparent',
    borderRadius: 6,
  },
  '#add_goal_page & > div.Advanced-options': {
    width: 'auto',
    marginLeft: 0,
  }
})
export default CoauthorButtonGroup;